
import React from "react";
import * as Hooks from "../../../../../hooks";
import { i18nManager } from "../../../../../i18n";
import { Schemes, Utils } from "../../../../../utils";
import { Elements } from "../../../../shared/Elements";
import * as ReactRouterDom from "react-router-dom";
import { ConfirmDialog } from "../../../../shared/ConfirmDialog";
import LoadingGif from "../../../assets/images/loading_circle.gif";
import { Button, ButtonManageRef, DateInput, Dropdown, Form, FormControl, Scheme, Subscriber, TextInput, useSubscription } from "@rivtn/noseur";
import { CreateTournamentSectionProps, CreateTournamentSection } from "../CreateTournament";
import { TournamentStatus } from "../../../../../services";

function Final(props: CreateTournamentSectionProps) {

    const { active, tournamentEditionState, hostPublicId } = props;
    const labels = i18nManager.Labels.host.create_tournament.final;
    const [tournamentEdition, setTournamentEdition] = tournamentEditionState;

    React.useEffect(() => {

    }, []);

    return (<div className="create-tournament-f flow details" ref={props.ref}>
        {!active && (<div className="overlay" onClick={() => props.setActiveSection(CreateTournamentSection.FINAL, undefined, true)} />)}
        <Form className="content" scheme={Schemes.OMNEHOST} style={{ marginTop: 20, width: "100%", justifyContent: "center", alignItems: "center" }}>
            <span style={{ maxWidth: 380, textAlign: "center" }}>{labels.desc}</span>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <Button raised scheme={Schemes.OMNEHOST} text={labels.go_to_manager_mode} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                    e.manageRef?.setLoadingState(true);
                    window.location.href = `/hosts/${hostPublicId}/tournament/${tournamentEdition.tournament?.external_id}`;
                }} />
                <div style={{ display: "flex", marginTop: 8, marginBottom: 8, }}>
                    <Button raised scheme={Schemes.OMNEHOST} text={labels.prev} style={{ flex: 1, marginRight: 4 }} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                        e.manageRef?.setLoadingState(true);
                        props.setActiveSection(CreateTournamentSection.SCORING_AND_TIE_BREAKING, () => {
                            e.manageRef?.setLoadingState(false);
                        });
                    }} />
                    <Button raised disabled scheme={Schemes.OMNEHOST} text={labels.next} style={{ flex: 1, marginLeft: 4 }} />
                </div>
                {(tournamentEdition.status === TournamentStatus.DRAFT) && (<Button fill raised scheme={Schemes.OMNEHOST} text={labels.publish} loadingProps={Elements.BUTTON_LOADING_PROPS} onClick={(e) => {
                    e.manageRef?.setLoadingState(true);
                    props.publish(() => {
                        e.manageRef?.setLoadingState(false);
                    });
                }} />)}
            </div>
        </Form>
    </div>);

}

export default Final;
